// doctor-frontend/src/pages/owner/CollegesHome.jsx
import React, { useEffect, useState } from 'react';
import { Box, Card, CardActionArea, CardContent, Typography, Grid, Stack, Button, CircularProgress, Alert, Divider } from '@mui/material';
import OwnerTopNav from '../../components/owner/OwnerTopNav';
import OwnerBrandFooter from '../../components/owner/OwnerBrandFooter';
import http from '../../services/http';

const ALLOWED_TENANTS = [
  'aiimsjodhpur-cmfm', // AIIMS Jodhpur
  'gomco-patiala',     // GOMCO Patiala
];

function openTenantInNewTab(slug) {
  const url = `/t/${encodeURIComponent(slug)}/cmfm-login`;
  // open in new tab, do not give the new page access back (security)
  window.open(url, '_blank', 'noopener');
}

export default function CollegesHome() {
  const [loading, setLoading] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [err, setErr] = useState('');

  useEffect(() => {
    let alive = true;
    (async () => {
      setLoading(true);
      setErr('');
      try {
        const { data } = await http.get('/api/owner/tenants');
        if (!alive) return;
        setTenants(data?.tenants || []);
      } catch (e) {
        if (!alive) return;
        setErr(e?.response?.data?.message || e?.message || 'Failed to load institutions');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
      <OwnerTopNav active="colleges" />
      <Box p={3}>
        <Typography variant="h6" sx={{ mb: 1 }}>Institutions</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Manage institutional deployments and available training modules. Undergraduate and postgraduate modules are planned;
          the internship module is currently enabled for selected institutional deployments.
        </Typography>
        <Divider sx={{ mb: 2 }} />

        {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
        {loading && !err && <CircularProgress size={20} />}

        {!loading && !err && (
          <Grid container spacing={2}>
            {tenants.map((t) => {
              const slug = (t.slug || '').toLowerCase();
              const allowed = ALLOWED_TENANTS.includes(slug);
              return (
                <Grid key={t.slug} item xs={12} sm={6} md={4} lg={3}>
                  <Card variant="outlined" sx={{ height: '100%', bgcolor: 'background.paper' }}>
                    {/* Keep existing owner-side navigation to subjects page */}
                    <CardActionArea href={`/owner/colleges/${encodeURIComponent(t.slug)}/subjects`}>
                      <CardContent>
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{t.name}</Typography>
                        <Typography variant="caption" color="text.secondary">{t.slug}</Typography>
                        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
                          <Button
                            variant="contained"
                            size="small"
                            onClick={(e) => { e.preventDefault(); openTenantInNewTab(t.slug); }}
                            disabled={!allowed}
                          >
                            {allowed ? 'Open Intern Module' : 'Coming soon'}
                          </Button>
                        </Stack>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}
        <OwnerBrandFooter />
      </Box>
    </Box>
  );
}
